// I hate everything about this, but PurgeCSS needs classes to be fully written out in the code.
// That means we can't dynamically build these classes, which I'd much rather do.
// So we have to list out this giant object of all the classes that we might be using in Craft.

export const marginConversions = {
  'm-auto': 'm-auto',
  'm-0': 'm-0',
  'm-2': 'm-0.5',
  'm-4': 'm-1',
  'm-6': 'm-1.5',
  'm-8': 'm-2',
  'm-10': 'm-2.5',
  'm-12': 'm-3',
  'm-16': 'm-4',
  'm-20': 'm-5',
  'm-24': 'm-6',
  'm-28': 'm-7',
  'm-32': 'm-8',
  'm-36': 'm-9',
  'm-40': 'm-10',
  'm-44': 'm-11',
  'm-48': 'm-12',
  'm-54': 'm-[3.25rem]',
  'm-55': 'm-[55px]',
  'm-56': 'm-14',
  'm-60': 'm-[3.75rem]',
  'm-64': 'm-16',
  'm-72': 'm-[4.5rem]',
  'm-80': 'm-20',
  'm-88': 'm-[5.5rem]',
  'm-96': 'm-24',
  'm-104': 'm-[6.5rem]',
  'm-105': 'm-[105px]',
  'm-112': 'm-28',
  'm-120': 'm-[7.5rem]',
  'm-128': 'm-32',
  'm-156': 'm-[9.75rem]',
  'm-170': 'm-[10.625rem]',
  'm-220': 'm-[13.75rem]',
  'm-270': 'm-[16.875rem]',
  'm-340': 'm-[21.25rem]',
  'm-460': 'm-[28.75rem]',
  'mt-auto': 'mt-auto',
  'mt-0': 'mt-0',
  'mt-2': 'mt-0.5',
  'mt-4': 'mt-1',
  'mt-6': 'mt-1.5',
  'mt-8': 'mt-2',
  'mt-10': 'mt-2.5',
  'mt-12': 'mt-3',
  'mt-16': 'mt-4',
  'mt-20': 'mt-5',
  'mt-24': 'mt-6',
  'mt-28': 'mt-7',
  'mt-32': 'mt-8',
  'mt-36': 'mt-9',
  'mt-40': 'mt-10',
  'mt-44': 'mt-11',
  'mt-48': 'mt-12',
  'mt-54': 'mt-[3.25rem]',
  'mt-55': 'mt-[55px]',
  'mt-56': 'mt-14',
  'mt-60': 'mt-[3.75rem]',
  'mt-64': 'mt-16',
  'mt-72': 'mt-[4.5rem]',
  'mt-80': 'mt-20',
  'mt-88': 'mt-[5.5rem]',
  'mt-96': 'mt-24',
  'mt-104': 'mt-[6.5rem]',
  'mt-105': 'mt-[105px]',
  'mt-112': 'mt-28',
  'mt-120': 'mt-[7.5rem]',
  'mt-128': 'mt-32',
  'mt-156': 'mt-[9.75rem]',
  'mt-170': 'mt-[10.625rem]',
  'mt-220': 'mt-[13.75rem]',
  'mt-270': 'mt-[16.875rem]',
  'mt-340': 'mt-[21.25rem]',
  'mt-460': 'mt-[28.75rem]',
  'mb-auto': 'mb-auto',
  'mb-0': 'mb-0',
  'mb-2': 'mb-0.5',
  'mb-4': 'mb-1',
  'mb-6': 'mb-1.5',
  'mb-8': 'mb-2',
  'mb-10': 'mb-2.5',
  'mb-12': 'mb-3',
  'mb-16': 'mb-4',
  'mb-20': 'mb-5',
  'mb-24': 'mb-6',
  'mb-28': 'mb-7',
  'mb-32': 'mb-8',
  'mb-36': 'mb-9',
  'mb-40': 'mb-10',
  'mb-44': 'mb-11',
  'mb-48': 'mb-12',
  'mb-54': 'mb-[3.25rem]',
  'mb-55': 'mb-[55px]',
  'mb-56': 'mb-14',
  'mb-60': 'mb-[3.75rem]',
  'mb-64': 'mb-16',
  'mb-72': 'mb-[4.5rem]',
  'mb-80': 'mb-20',
  'mb-88': 'mb-[5.5rem]',
  'mb-96': 'mb-24',
  'mb-104': 'mb-[6.5rem]',
  'mb-105': 'mb-[105px]',
  'mb-112': 'mb-28',
  'mb-120': 'mb-[7.5rem]',
  'mb-128': 'mb-32',
  'mb-156': 'mb-[9.75rem]',
  'mb-170': 'mb-[10.625rem]',
  'mb-220': 'mb-[13.75rem]',
  'mb-270': 'mb-[16.875rem]',
  'mb-340': 'mb-[21.25rem]',
  'mb-460': 'mb-[28.75rem]',
  'ml-auto': 'ml-auto',
  'ml-0': 'ml-0',
  'ml-2': 'ml-0.5',
  'ml-4': 'ml-1',
  'ml-6': 'ml-1.5',
  'ml-8': 'ml-2',
  'ml-10': 'ml-2.5',
  'ml-12': 'ml-3',
  'ml-16': 'ml-4',
  'ml-20': 'ml-5',
  'ml-24': 'ml-6',
  'ml-28': 'ml-7',
  'ml-32': 'ml-8',
  'ml-36': 'ml-9',
  'ml-40': 'ml-10',
  'ml-44': 'ml-11',
  'ml-48': 'ml-12',
  'ml-54': 'ml-[3.25rem]',
  'ml-55': 'ml-[55px]',
  'ml-56': 'ml-14',
  'ml-60': 'ml-[3.75rem]',
  'ml-64': 'ml-16',
  'ml-72': 'ml-[4.5rem]',
  'ml-80': 'ml-20',
  'ml-88': 'ml-[5.5rem]',
  'ml-96': 'ml-24',
  'ml-104': 'ml-[6.5rem]',
  'ml-105': 'ml-[105px]',
  'ml-112': 'ml-28',
  'ml-120': 'ml-[7.5rem]',
  'ml-128': 'ml-32',
  'ml-156': 'ml-[9.75rem]',
  'ml-170': 'ml-[10.625rem]',
  'ml-220': 'ml-[13.75rem]',
  'ml-270': 'ml-[16.875rem]',
  'ml-340': 'ml-[21.25rem]',
  'ml-460': 'ml-[28.75rem]',
  'mr-auto': 'mr-auto',
  'mr-0': 'mr-0',
  'mr-2': 'mr-0.5',
  'mr-4': 'mr-1',
  'mr-6': 'mr-1.5',
  'mr-8': 'mr-2',
  'mr-10': 'mr-2.5',
  'mr-12': 'mr-3',
  'mr-16': 'mr-4',
  'mr-20': 'mr-5',
  'mr-24': 'mr-6',
  'mr-28': 'mr-7',
  'mr-32': 'mr-8',
  'mr-36': 'mr-9',
  'mr-40': 'mr-10',
  'mr-44': 'mr-11',
  'mr-48': 'mr-12',
  'mr-54': 'mr-[3.25rem]',
  'mr-55': 'mr-[55px]',
  'mr-56': 'mr-14',
  'mr-60': 'mr-[3.75rem]',
  'mr-64': 'mr-16',
  'mr-72': 'mr-[4.5rem]',
  'mr-80': 'mr-20',
  'mr-88': 'mr-[5.5rem]',
  'mr-96': 'mr-24',
  'mr-104': 'mr-[6.5rem]',
  'mr-105': 'mr-[105px]',
  'mr-112': 'mr-28',
  'mr-120': 'mr-[7.5rem]',
  'mr-128': 'mr-32',
  'mr-156': 'mr-[9.75rem]',
  'mr-170': 'mr-[10.625rem]',
  'mr-220': 'mr-[13.75rem]',
  'mr-270': 'mr-[16.875rem]',
  'mr-340': 'mr-[21.25rem]',
  'mr-460': 'mr-[28.75rem]',
  'mx-auto': 'mx-auto',
  'mx-0': 'mx-0',
  'mx-2': 'mx-0.5',
  'mx-4': 'mx-1',
  'mx-6': 'mx-1.5',
  'mx-8': 'mx-2',
  'mx-10': 'mx-2.5',
  'mx-12': 'mx-3',
  'mx-16': 'mx-4',
  'mx-20': 'mx-5',
  'mx-24': 'mx-6',
  'mx-28': 'mx-7',
  'mx-32': 'mx-8',
  'mx-36': 'mx-9',
  'mx-40': 'mx-10',
  'mx-44': 'mx-11',
  'mx-48': 'mx-12',
  'mx-54': 'mx-[3.25rem]',
  'mx-55': 'mx-[55px]',
  'mx-56': 'mx-14',
  'mx-60': 'mx-[3.75rem]',
  'mx-64': 'mx-16',
  'mx-72': 'mx-[4.5rem]',
  'mx-80': 'mx-20',
  'mx-88': 'mx-[5.5rem]',
  'mx-96': 'mx-24',
  'mx-104': 'mx-[6.5rem]',
  'mx-105': 'mx-[105px]',
  'mx-112': 'mx-28',
  'mx-120': 'mx-[7.5rem]',
  'mx-128': 'mx-32',
  'mx-156': 'mx-[9.75rem]',
  'mx-170': 'mx-[10.625rem]',
  'mx-220': 'mx-[13.75rem]',
  'mx-270': 'mx-[16.875rem]',
  'mx-340': 'mx-[21.25rem]',
  'mx-460': 'mx-[28.75rem]',
  'my-auto': 'my-auto',
  'my-0': 'my-0',
  'my-2': 'my-0.5',
  'my-4': 'my-1',
  'my-6': 'my-1.5',
  'my-8': 'my-2',
  'my-10': 'my-2.5',
  'my-12': 'my-3',
  'my-16': 'my-4',
  'my-20': 'my-5',
  'my-24': 'my-6',
  'my-28': 'my-7',
  'my-32': 'my-8',
  'my-36': 'my-9',
  'my-40': 'my-10',
  'my-44': 'my-11',
  'my-48': 'my-12',
  'my-54': 'my-[3.25rem]',
  'my-55': 'my-[55px]',
  'my-56': 'my-14',
  'my-60': 'my-[3.75rem]',
  'my-64': 'my-16',
  'my-72': 'my-[4.5rem]',
  'my-80': 'my-20',
  'my-88': 'my-[5.5rem]',
  'my-96': 'my-24',
  'my-104': 'my-[6.5rem]',
  'my-105': 'my-[105px]',
  'my-112': 'my-28',
  'my-120': 'my-[7.5rem]',
  'my-128': 'my-32',
  'my-156': 'my-[9.75rem]',
  'my-170': 'my-[10.625rem]',
  'my-220': 'my-[13.75rem]',
  'my-270': 'my-[16.875rem]',
  'my-340': 'my-[21.25rem]',
  'my-460': 'my-[28.75rem]',
  'sm:m-auto': 'sm:m-auto',
  'sm:m-0': 'sm:m-0',
  'sm:m-2': 'sm:m-0.5',
  'sm:m-4': 'sm:m-1',
  'sm:m-6': 'sm:m-1.5',
  'sm:m-8': 'sm:m-2',
  'sm:m-10': 'sm:m-2.5',
  'sm:m-12': 'sm:m-3',
  'sm:m-16': 'sm:m-4',
  'sm:m-20': 'sm:m-5',
  'sm:m-24': 'sm:m-6',
  'sm:m-28': 'sm:m-7',
  'sm:m-32': 'sm:m-8',
  'sm:m-36': 'sm:m-9',
  'sm:m-40': 'sm:m-10',
  'sm:m-44': 'sm:m-11',
  'sm:m-48': 'sm:m-12',
  'sm:m-54': 'sm:m-[3.25rem]',
  'sm:m-55': 'sm:m-[55px]',
  'sm:m-56': 'sm:m-14',
  'sm:m-60': 'sm:m-[3.75rem]',
  'sm:m-64': 'sm:m-16',
  'sm:m-72': 'sm:m-[4.5rem]',
  'sm:m-80': 'sm:m-20',
  'sm:m-88': 'sm:m-[5.5rem]',
  'sm:m-96': 'sm:m-24',
  'sm:m-104': 'sm:m-[6.5rem]',
  'sm:m-105': 'sm:m-[105px]',
  'sm:m-112': 'sm:m-28',
  'sm:m-120': 'sm:m-[7.5rem]',
  'sm:m-128': 'sm:m-32',
  'sm:m-156': 'sm:m-[9.75rem]',
  'sm:m-170': 'sm:m-[10.625rem]',
  'sm:m-220': 'sm:m-[13.75rem]',
  'sm:m-270': 'sm:m-[16.875rem]',
  'sm:m-340': 'sm:m-[21.25rem]',
  'sm:m-460': 'sm:m-[28.75rem]',
  'sm:mt-auto': 'sm:mt-auto',
  'sm:mt-0': 'sm:mt-0',
  'sm:mt-2': 'sm:mt-0.5',
  'sm:mt-4': 'sm:mt-1',
  'sm:mt-6': 'sm:mt-1.5',
  'sm:mt-8': 'sm:mt-2',
  'sm:mt-10': 'sm:mt-2.5',
  'sm:mt-12': 'sm:mt-3',
  'sm:mt-16': 'sm:mt-4',
  'sm:mt-20': 'sm:mt-5',
  'sm:mt-24': 'sm:mt-6',
  'sm:mt-28': 'sm:mt-7',
  'sm:mt-32': 'sm:mt-8',
  'sm:mt-36': 'sm:mt-9',
  'sm:mt-40': 'sm:mt-10',
  'sm:mt-44': 'sm:mt-11',
  'sm:mt-48': 'sm:mt-12',
  'sm:mt-54': 'sm:mt-[3.25rem]',
  'sm:mt-55': 'sm:mt-[55px]',
  'sm:mt-56': 'sm:mt-14',
  'sm:mt-60': 'sm:mt-[3.75rem]',
  'sm:mt-64': 'sm:mt-16',
  'sm:mt-72': 'sm:mt-[4.5rem]',
  'sm:mt-80': 'sm:mt-20',
  'sm:mt-88': 'sm:mt-[5.5rem]',
  'sm:mt-96': 'sm:mt-24',
  'sm:mt-104': 'sm:mt-[6.5rem]',
  'sm:mt-105': 'sm:mt-[105px]',
  'sm:mt-112': 'sm:mt-28',
  'sm:mt-120': 'sm:mt-[7.5rem]',
  'sm:mt-128': 'sm:mt-32',
  'sm:mt-156': 'sm:mt-[9.75rem]',
  'sm:mt-170': 'sm:mt-[10.625rem]',
  'sm:mt-220': 'sm:mt-[13.75rem]',
  'sm:mt-270': 'sm:mt-[16.875rem]',
  'sm:mt-340': 'sm:mt-[21.25rem]',
  'sm:mt-460': 'sm:mt-[28.75rem]',
  'sm:mb-auto': 'sm:mb-auto',
  'sm:mb-0': 'sm:mb-0',
  'sm:mb-2': 'sm:mb-0.5',
  'sm:mb-4': 'sm:mb-1',
  'sm:mb-6': 'sm:mb-1.5',
  'sm:mb-8': 'sm:mb-2',
  'sm:mb-10': 'sm:mb-2.5',
  'sm:mb-12': 'sm:mb-3',
  'sm:mb-16': 'sm:mb-4',
  'sm:mb-20': 'sm:mb-5',
  'sm:mb-24': 'sm:mb-6',
  'sm:mb-28': 'sm:mb-7',
  'sm:mb-32': 'sm:mb-8',
  'sm:mb-36': 'sm:mb-9',
  'sm:mb-40': 'sm:mb-10',
  'sm:mb-44': 'sm:mb-11',
  'sm:mb-48': 'sm:mb-12',
  'sm:mb-54': 'sm:mb-[3.25rem]',
  'sm:mb-55': 'sm:mb-[55px]',
  'sm:mb-56': 'sm:mb-14',
  'sm:mb-60': 'sm:mb-[3.75rem]',
  'sm:mb-64': 'sm:mb-16',
  'sm:mb-72': 'sm:mb-[4.5rem]',
  'sm:mb-80': 'sm:mb-20',
  'sm:mb-88': 'sm:mb-[5.5rem]',
  'sm:mb-96': 'sm:mb-24',
  'sm:mb-104': 'sm:mb-[6.5rem]',
  'sm:mb-105': 'sm:mb-[105px]',
  'sm:mb-112': 'sm:mb-28',
  'sm:mb-120': 'sm:mb-[7.5rem]',
  'sm:mb-128': 'sm:mb-32',
  'sm:mb-156': 'sm:mb-[9.75rem]',
  'sm:mb-170': 'sm:mb-[10.625rem]',
  'sm:mb-220': 'sm:mb-[13.75rem]',
  'sm:mb-270': 'sm:mb-[16.875rem]',
  'sm:mb-340': 'sm:mb-[21.25rem]',
  'sm:mb-460': 'sm:mb-[28.75rem]',
  'sm:ml-auto': 'sm:ml-auto',
  'sm:ml-0': 'sm:ml-0',
  'sm:ml-2': 'sm:ml-0.5',
  'sm:ml-4': 'sm:ml-1',
  'sm:ml-6': 'sm:ml-1.5',
  'sm:ml-8': 'sm:ml-2',
  'sm:ml-10': 'sm:ml-2.5',
  'sm:ml-12': 'sm:ml-3',
  'sm:ml-16': 'sm:ml-4',
  'sm:ml-20': 'sm:ml-5',
  'sm:ml-24': 'sm:ml-6',
  'sm:ml-28': 'sm:ml-7',
  'sm:ml-32': 'sm:ml-8',
  'sm:ml-36': 'sm:ml-9',
  'sm:ml-40': 'sm:ml-10',
  'sm:ml-44': 'sm:ml-11',
  'sm:ml-48': 'sm:ml-12',
  'sm:ml-54': 'sm:ml-[3.25rem]',
  'sm:ml-55': 'sm:ml-[55px]',
  'sm:ml-56': 'sm:ml-14',
  'sm:ml-60': 'sm:ml-[3.75rem]',
  'sm:ml-64': 'sm:ml-16',
  'sm:ml-72': 'sm:ml-[4.5rem]',
  'sm:ml-80': 'sm:ml-20',
  'sm:ml-88': 'sm:ml-[5.5rem]',
  'sm:ml-96': 'sm:ml-24',
  'sm:ml-104': 'sm:ml-[6.5rem]',
  'sm:ml-105': 'sm:ml-[105px]',
  'sm:ml-112': 'sm:ml-28',
  'sm:ml-120': 'sm:ml-[7.5rem]',
  'sm:ml-128': 'sm:ml-32',
  'sm:ml-156': 'sm:ml-[9.75rem]',
  'sm:ml-170': 'sm:ml-[10.625rem]',
  'sm:ml-220': 'sm:ml-[13.75rem]',
  'sm:ml-270': 'sm:ml-[16.875rem]',
  'sm:ml-340': 'sm:ml-[21.25rem]',
  'sm:ml-460': 'sm:ml-[28.75rem]',
  'sm:mr-auto': 'sm:mr-auto',
  'sm:mr-0': 'sm:mr-0',
  'sm:mr-2': 'sm:mr-0.5',
  'sm:mr-4': 'sm:mr-1',
  'sm:mr-6': 'sm:mr-1.5',
  'sm:mr-8': 'sm:mr-2',
  'sm:mr-10': 'sm:mr-2.5',
  'sm:mr-12': 'sm:mr-3',
  'sm:mr-16': 'sm:mr-4',
  'sm:mr-20': 'sm:mr-5',
  'sm:mr-24': 'sm:mr-6',
  'sm:mr-28': 'sm:mr-7',
  'sm:mr-32': 'sm:mr-8',
  'sm:mr-36': 'sm:mr-9',
  'sm:mr-40': 'sm:mr-10',
  'sm:mr-44': 'sm:mr-11',
  'sm:mr-48': 'sm:mr-12',
  'sm:mr-54': 'sm:mr-[3.25rem]',
  'sm:mr-55': 'sm:mr-[55px]',
  'sm:mr-56': 'sm:mr-14',
  'sm:mr-60': 'sm:mr-[3.75rem]',
  'sm:mr-64': 'sm:mr-16',
  'sm:mr-72': 'sm:mr-[4.5rem]',
  'sm:mr-80': 'sm:mr-20',
  'sm:mr-88': 'sm:mr-[5.5rem]',
  'sm:mr-96': 'sm:mr-24',
  'sm:mr-104': 'sm:mr-[6.5rem]',
  'sm:mr-105': 'sm:mr-[105px]',
  'sm:mr-112': 'sm:mr-28',
  'sm:mr-120': 'sm:mr-[7.5rem]',
  'sm:mr-128': 'sm:mr-32',
  'sm:mr-156': 'sm:mr-[9.75rem]',
  'sm:mr-170': 'sm:mr-[10.625rem]',
  'sm:mr-220': 'sm:mr-[13.75rem]',
  'sm:mr-270': 'sm:mr-[16.875rem]',
  'sm:mr-340': 'sm:mr-[21.25rem]',
  'sm:mr-460': 'sm:mr-[28.75rem]',
  'sm:mx-auto': 'sm:mx-auto',
  'sm:mx-0': 'sm:mx-0',
  'sm:mx-2': 'sm:mx-0.5',
  'sm:mx-4': 'sm:mx-1',
  'sm:mx-6': 'sm:mx-1.5',
  'sm:mx-8': 'sm:mx-2',
  'sm:mx-10': 'sm:mx-2.5',
  'sm:mx-12': 'sm:mx-3',
  'sm:mx-16': 'sm:mx-4',
  'sm:mx-20': 'sm:mx-5',
  'sm:mx-24': 'sm:mx-6',
  'sm:mx-28': 'sm:mx-7',
  'sm:mx-32': 'sm:mx-8',
  'sm:mx-36': 'sm:mx-9',
  'sm:mx-40': 'sm:mx-10',
  'sm:mx-44': 'sm:mx-11',
  'sm:mx-48': 'sm:mx-12',
  'sm:mx-54': 'sm:mx-[3.25rem]',
  'sm:mx-55': 'sm:mx-[55px]',
  'sm:mx-56': 'sm:mx-14',
  'sm:mx-60': 'sm:mx-[3.75rem]',
  'sm:mx-64': 'sm:mx-16',
  'sm:mx-72': 'sm:mx-[4.5rem]',
  'sm:mx-80': 'sm:mx-20',
  'sm:mx-88': 'sm:mx-[5.5rem]',
  'sm:mx-96': 'sm:mx-24',
  'sm:mx-104': 'sm:mx-[6.5rem]',
  'sm:mx-105': 'sm:mx-[105px]',
  'sm:mx-112': 'sm:mx-28',
  'sm:mx-120': 'sm:mx-[7.5rem]',
  'sm:mx-128': 'sm:mx-32',
  'sm:mx-156': 'sm:mx-[9.75rem]',
  'sm:mx-170': 'sm:mx-[10.625rem]',
  'sm:mx-220': 'sm:mx-[13.75rem]',
  'sm:mx-270': 'sm:mx-[16.875rem]',
  'sm:mx-340': 'sm:mx-[21.25rem]',
  'sm:mx-460': 'sm:mx-[28.75rem]',
  'sm:my-auto': 'sm:my-auto',
  'sm:my-0': 'sm:my-0',
  'sm:my-2': 'sm:my-0.5',
  'sm:my-4': 'sm:my-1',
  'sm:my-6': 'sm:my-1.5',
  'sm:my-8': 'sm:my-2',
  'sm:my-10': 'sm:my-2.5',
  'sm:my-12': 'sm:my-3',
  'sm:my-16': 'sm:my-4',
  'sm:my-20': 'sm:my-5',
  'sm:my-24': 'sm:my-6',
  'sm:my-28': 'sm:my-7',
  'sm:my-32': 'sm:my-8',
  'sm:my-36': 'sm:my-9',
  'sm:my-40': 'sm:my-10',
  'sm:my-44': 'sm:my-11',
  'sm:my-48': 'sm:my-12',
  'sm:my-54': 'sm:my-[3.25rem]',
  'sm:my-55': 'sm:my-[55px]',
  'sm:my-56': 'sm:my-14',
  'sm:my-60': 'sm:my-[3.75rem]',
  'sm:my-64': 'sm:my-16',
  'sm:my-72': 'sm:my-[4.5rem]',
  'sm:my-80': 'sm:my-20',
  'sm:my-88': 'sm:my-[5.5rem]',
  'sm:my-96': 'sm:my-24',
  'sm:my-104': 'sm:my-[6.5rem]',
  'sm:my-105': 'sm:my-[105px]',
  'sm:my-112': 'sm:my-28',
  'sm:my-120': 'sm:my-[7.5rem]',
  'sm:my-128': 'sm:my-32',
  'sm:my-156': 'sm:my-[9.75rem]',
  'sm:my-170': 'sm:my-[10.625rem]',
  'sm:my-220': 'sm:my-[13.75rem]',
  'sm:my-270': 'sm:my-[16.875rem]',
  'sm:my-340': 'sm:my-[21.25rem]',
  'sm:my-460': 'sm:my-[28.75rem]',
  'md:m-auto': 'md:m-auto',
  'md:m-0': 'md:m-0',
  'md:m-2': 'md:m-0.5',
  'md:m-4': 'md:m-1',
  'md:m-6': 'md:m-1.5',
  'md:m-8': 'md:m-2',
  'md:m-10': 'md:m-2.5',
  'md:m-12': 'md:m-3',
  'md:m-16': 'md:m-4',
  'md:m-20': 'md:m-5',
  'md:m-24': 'md:m-6',
  'md:m-28': 'md:m-7',
  'md:m-32': 'md:m-8',
  'md:m-36': 'md:m-9',
  'md:m-40': 'md:m-10',
  'md:m-44': 'md:m-11',
  'md:m-48': 'md:m-12',
  'md:m-54': 'md:m-[3.25rem]',
  'md:m-55': 'md:m-[55px]',
  'md:m-56': 'md:m-14',
  'md:m-60': 'md:m-[3.75rem]',
  'md:m-64': 'md:m-16',
  'md:m-72': 'md:m-[4.5rem]',
  'md:m-80': 'md:m-20',
  'md:m-88': 'md:m-[5.5rem]',
  'md:m-96': 'md:m-24',
  'md:m-104': 'md:m-[6.5rem]',
  'md:m-105': 'md:m-[105px]',
  'md:m-112': 'md:m-28',
  'md:m-120': 'md:m-[7.5rem]',
  'md:m-128': 'md:m-32',
  'md:m-156': 'md:m-[9.75rem]',
  'md:m-170': 'md:m-[10.625rem]',
  'md:m-220': 'md:m-[13.75rem]',
  'md:m-270': 'md:m-[16.875rem]',
  'md:m-340': 'md:m-[21.25rem]',
  'md:m-460': 'md:m-[28.75rem]',
  'md:mt-auto': 'md:mt-auto',
  'md:mt-0': 'md:mt-0',
  'md:mt-2': 'md:mt-0.5',
  'md:mt-4': 'md:mt-1',
  'md:mt-6': 'md:mt-1.5',
  'md:mt-8': 'md:mt-2',
  'md:mt-10': 'md:mt-2.5',
  'md:mt-12': 'md:mt-3',
  'md:mt-16': 'md:mt-4',
  'md:mt-20': 'md:mt-5',
  'md:mt-24': 'md:mt-6',
  'md:mt-28': 'md:mt-7',
  'md:mt-32': 'md:mt-8',
  'md:mt-36': 'md:mt-9',
  'md:mt-40': 'md:mt-10',
  'md:mt-44': 'md:mt-11',
  'md:mt-48': 'md:mt-12',
  'md:mt-54': 'md:mt-[3.25rem]',
  'md:mt-55': 'md:mt-[55px]',
  'md:mt-56': 'md:mt-14',
  'md:mt-60': 'md:mt-[3.75rem]',
  'md:mt-64': 'md:mt-16',
  'md:mt-72': 'md:mt-[4.5rem]',
  'md:mt-80': 'md:mt-20',
  'md:mt-88': 'md:mt-[5.5rem]',
  'md:mt-96': 'md:mt-24',
  'md:mt-104': 'md:mt-[6.5rem]',
  'md:mt-105': 'md:mt-[105px]',
  'md:mt-112': 'md:mt-28',
  'md:mt-120': 'md:mt-[7.5rem]',
  'md:mt-128': 'md:mt-32',
  'md:mt-156': 'md:mt-[9.75rem]',
  'md:mt-170': 'md:mt-[10.625rem]',
  'md:mt-220': 'md:mt-[13.75rem]',
  'md:mt-270': 'md:mt-[16.875rem]',
  'md:mt-340': 'md:mt-[21.25rem]',
  'md:mt-460': 'md:mt-[28.75rem]',
  'md:mb-auto': 'md:mb-auto',
  'md:mb-0': 'md:mb-0',
  'md:mb-2': 'md:mb-0.5',
  'md:mb-4': 'md:mb-1',
  'md:mb-6': 'md:mb-1.5',
  'md:mb-8': 'md:mb-2',
  'md:mb-10': 'md:mb-2.5',
  'md:mb-12': 'md:mb-3',
  'md:mb-16': 'md:mb-4',
  'md:mb-20': 'md:mb-5',
  'md:mb-24': 'md:mb-6',
  'md:mb-28': 'md:mb-7',
  'md:mb-32': 'md:mb-8',
  'md:mb-36': 'md:mb-9',
  'md:mb-40': 'md:mb-10',
  'md:mb-44': 'md:mb-11',
  'md:mb-48': 'md:mb-12',
  'md:mb-54': 'md:mb-[3.25rem]',
  'md:mb-55': 'md:mb-[55px]',
  'md:mb-56': 'md:mb-14',
  'md:mb-60': 'md:mb-[3.75rem]',
  'md:mb-64': 'md:mb-16',
  'md:mb-72': 'md:mb-[4.5rem]',
  'md:mb-80': 'md:mb-20',
  'md:mb-88': 'md:mb-[5.5rem]',
  'md:mb-96': 'md:mb-24',
  'md:mb-104': 'md:mb-[6.5rem]',
  'md:mb-105': 'md:mb-[105px]',
  'md:mb-112': 'md:mb-28',
  'md:mb-120': 'md:mb-[7.5rem]',
  'md:mb-128': 'md:mb-32',
  'md:mb-156': 'md:mb-[9.75rem]',
  'md:mb-170': 'md:mb-[10.625rem]',
  'md:mb-220': 'md:mb-[13.75rem]',
  'md:mb-270': 'md:mb-[16.875rem]',
  'md:mb-340': 'md:mb-[21.25rem]',
  'md:mb-460': 'md:mb-[28.75rem]',
  'md:ml-auto': 'md:ml-auto',
  'md:ml-0': 'md:ml-0',
  'md:ml-2': 'md:ml-0.5',
  'md:ml-4': 'md:ml-1',
  'md:ml-6': 'md:ml-1.5',
  'md:ml-8': 'md:ml-2',
  'md:ml-10': 'md:ml-2.5',
  'md:ml-12': 'md:ml-3',
  'md:ml-16': 'md:ml-4',
  'md:ml-20': 'md:ml-5',
  'md:ml-24': 'md:ml-6',
  'md:ml-28': 'md:ml-7',
  'md:ml-32': 'md:ml-8',
  'md:ml-36': 'md:ml-9',
  'md:ml-40': 'md:ml-10',
  'md:ml-44': 'md:ml-11',
  'md:ml-48': 'md:ml-12',
  'md:ml-54': 'md:ml-[3.25rem]',
  'md:ml-55': 'md:ml-[55px]',
  'md:ml-56': 'md:ml-14',
  'md:ml-60': 'md:ml-[3.75rem]',
  'md:ml-64': 'md:ml-16',
  'md:ml-72': 'md:ml-[4.5rem]',
  'md:ml-80': 'md:ml-20',
  'md:ml-88': 'md:ml-[5.5rem]',
  'md:ml-96': 'md:ml-24',
  'md:ml-104': 'md:ml-[6.5rem]',
  'md:ml-105': 'md:ml-[105px]',
  'md:ml-112': 'md:ml-28',
  'md:ml-120': 'md:ml-[7.5rem]',
  'md:ml-128': 'md:ml-32',
  'md:ml-156': 'md:ml-[9.75rem]',
  'md:ml-170': 'md:ml-[10.625rem]',
  'md:ml-220': 'md:ml-[13.75rem]',
  'md:ml-270': 'md:ml-[16.875rem]',
  'md:ml-340': 'md:ml-[21.25rem]',
  'md:ml-460': 'md:ml-[28.75rem]',
  'md:mr-auto': 'md:mr-auto',
  'md:mr-0': 'md:mr-0',
  'md:mr-2': 'md:mr-0.5',
  'md:mr-4': 'md:mr-1',
  'md:mr-6': 'md:mr-1.5',
  'md:mr-8': 'md:mr-2',
  'md:mr-10': 'md:mr-2.5',
  'md:mr-12': 'md:mr-3',
  'md:mr-16': 'md:mr-4',
  'md:mr-20': 'md:mr-5',
  'md:mr-24': 'md:mr-6',
  'md:mr-28': 'md:mr-7',
  'md:mr-32': 'md:mr-8',
  'md:mr-36': 'md:mr-9',
  'md:mr-40': 'md:mr-10',
  'md:mr-44': 'md:mr-11',
  'md:mr-48': 'md:mr-12',
  'md:mr-54': 'md:mr-[3.25rem]',
  'md:mr-55': 'md:mr-[55px]',
  'md:mr-56': 'md:mr-14',
  'md:mr-60': 'md:mr-[3.75rem]',
  'md:mr-64': 'md:mr-16',
  'md:mr-72': 'md:mr-[4.5rem]',
  'md:mr-80': 'md:mr-20',
  'md:mr-88': 'md:mr-[5.5rem]',
  'md:mr-96': 'md:mr-24',
  'md:mr-104': 'md:mr-[6.5rem]',
  'md:mr-105': 'md:mr-[105px]',
  'md:mr-112': 'md:mr-28',
  'md:mr-120': 'md:mr-[7.5rem]',
  'md:mr-128': 'md:mr-32',
  'md:mr-156': 'md:mr-[9.75rem]',
  'md:mr-170': 'md:mr-[10.625rem]',
  'md:mr-220': 'md:mr-[13.75rem]',
  'md:mr-270': 'md:mr-[16.875rem]',
  'md:mr-340': 'md:mr-[21.25rem]',
  'md:mr-460': 'md:mr-[28.75rem]',
  'md:mx-auto': 'md:mx-auto',
  'md:mx-0': 'md:mx-0',
  'md:mx-2': 'md:mx-0.5',
  'md:mx-4': 'md:mx-1',
  'md:mx-6': 'md:mx-1.5',
  'md:mx-8': 'md:mx-2',
  'md:mx-10': 'md:mx-2.5',
  'md:mx-12': 'md:mx-3',
  'md:mx-16': 'md:mx-4',
  'md:mx-20': 'md:mx-5',
  'md:mx-24': 'md:mx-6',
  'md:mx-28': 'md:mx-7',
  'md:mx-32': 'md:mx-8',
  'md:mx-36': 'md:mx-9',
  'md:mx-40': 'md:mx-10',
  'md:mx-44': 'md:mx-11',
  'md:mx-48': 'md:mx-12',
  'md:mx-54': 'md:mx-[3.25rem]',
  'md:mx-55': 'md:mx-[55px]',
  'md:mx-56': 'md:mx-14',
  'md:mx-60': 'md:mx-[3.75rem]',
  'md:mx-64': 'md:mx-16',
  'md:mx-72': 'md:mx-[4.5rem]',
  'md:mx-80': 'md:mx-20',
  'md:mx-88': 'md:mx-[5.5rem]',
  'md:mx-96': 'md:mx-24',
  'md:mx-104': 'md:mx-[6.5rem]',
  'md:mx-105': 'md:mx-[105px]',
  'md:mx-112': 'md:mx-28',
  'md:mx-120': 'md:mx-[7.5rem]',
  'md:mx-128': 'md:mx-32',
  'md:mx-156': 'md:mx-[9.75rem]',
  'md:mx-170': 'md:mx-[10.625rem]',
  'md:mx-220': 'md:mx-[13.75rem]',
  'md:mx-270': 'md:mx-[16.875rem]',
  'md:mx-340': 'md:mx-[21.25rem]',
  'md:mx-460': 'md:mx-[28.75rem]',
  'md:my-auto': 'md:my-auto',
  'md:my-0': 'md:my-0',
  'md:my-2': 'md:my-0.5',
  'md:my-4': 'md:my-1',
  'md:my-6': 'md:my-1.5',
  'md:my-8': 'md:my-2',
  'md:my-10': 'md:my-2.5',
  'md:my-12': 'md:my-3',
  'md:my-16': 'md:my-4',
  'md:my-20': 'md:my-5',
  'md:my-24': 'md:my-6',
  'md:my-28': 'md:my-7',
  'md:my-32': 'md:my-8',
  'md:my-36': 'md:my-9',
  'md:my-40': 'md:my-10',
  'md:my-44': 'md:my-11',
  'md:my-48': 'md:my-12',
  'md:my-54': 'md:my-[3.25rem]',
  'md:my-55': 'md:my-[55px]',
  'md:my-56': 'md:my-14',
  'md:my-60': 'md:my-[3.75rem]',
  'md:my-64': 'md:my-16',
  'md:my-72': 'md:my-[4.5rem]',
  'md:my-80': 'md:my-20',
  'md:my-88': 'md:my-[5.5rem]',
  'md:my-96': 'md:my-24',
  'md:my-104': 'md:my-[6.5rem]',
  'md:my-105': 'md:my-[105px]',
  'md:my-112': 'md:my-28',
  'md:my-120': 'md:my-[7.5rem]',
  'md:my-128': 'md:my-32',
  'md:my-156': 'md:my-[9.75rem]',
  'md:my-170': 'md:my-[10.625rem]',
  'md:my-220': 'md:my-[13.75rem]',
  'md:my-270': 'md:my-[16.875rem]',
  'md:my-340': 'md:my-[21.25rem]',
  'md:my-460': 'md:my-[28.75rem]',
  'lg:m-auto': 'lg:m-auto',
  'lg:m-0': 'lg:m-0',
  'lg:m-2': 'lg:m-0.5',
  'lg:m-4': 'lg:m-1',
  'lg:m-6': 'lg:m-1.5',
  'lg:m-8': 'lg:m-2',
  'lg:m-10': 'lg:m-2.5',
  'lg:m-12': 'lg:m-3',
  'lg:m-16': 'lg:m-4',
  'lg:m-20': 'lg:m-5',
  'lg:m-24': 'lg:m-6',
  'lg:m-28': 'lg:m-7',
  'lg:m-32': 'lg:m-8',
  'lg:m-36': 'lg:m-9',
  'lg:m-40': 'lg:m-10',
  'lg:m-44': 'lg:m-11',
  'lg:m-48': 'lg:m-12',
  'lg:m-54': 'lg:m-[3.25rem]',
  'lg:m-55': 'lg:m-[55px]',
  'lg:m-56': 'lg:m-14',
  'lg:m-60': 'lg:m-[3.75rem]',
  'lg:m-64': 'lg:m-16',
  'lg:m-72': 'lg:m-[4.5rem]',
  'lg:m-80': 'lg:m-20',
  'lg:m-88': 'lg:m-[5.5rem]',
  'lg:m-96': 'lg:m-24',
  'lg:m-104': 'lg:m-[6.5rem]',
  'lg:m-105': 'lg:m-[105px]',
  'lg:m-112': 'lg:m-28',
  'lg:m-120': 'lg:m-[7.5rem]',
  'lg:m-128': 'lg:m-32',
  'lg:m-156': 'lg:m-[9.75rem]',
  'lg:m-170': 'lg:m-[10.625rem]',
  'lg:m-220': 'lg:m-[13.75rem]',
  'lg:m-270': 'lg:m-[16.875rem]',
  'lg:m-340': 'lg:m-[21.25rem]',
  'lg:m-460': 'lg:m-[28.75rem]',
  'lg:mt-auto': 'lg:mt-auto',
  'lg:mt-0': 'lg:mt-0',
  'lg:mt-2': 'lg:mt-0.5',
  'lg:mt-4': 'lg:mt-1',
  'lg:mt-6': 'lg:mt-1.5',
  'lg:mt-8': 'lg:mt-2',
  'lg:mt-10': 'lg:mt-2.5',
  'lg:mt-12': 'lg:mt-3',
  'lg:mt-16': 'lg:mt-4',
  'lg:mt-20': 'lg:mt-5',
  'lg:mt-24': 'lg:mt-6',
  'lg:mt-28': 'lg:mt-7',
  'lg:mt-32': 'lg:mt-8',
  'lg:mt-36': 'lg:mt-9',
  'lg:mt-40': 'lg:mt-10',
  'lg:mt-44': 'lg:mt-11',
  'lg:mt-48': 'lg:mt-12',
  'lg:mt-54': 'lg:mt-[3.25rem]',
  'lg:mt-55': 'lg:mt-[55px]',
  'lg:mt-56': 'lg:mt-14',
  'lg:mt-60': 'lg:mt-[3.75rem]',
  'lg:mt-64': 'lg:mt-16',
  'lg:mt-72': 'lg:mt-[4.5rem]',
  'lg:mt-80': 'lg:mt-20',
  'lg:mt-88': 'lg:mt-[5.5rem]',
  'lg:mt-96': 'lg:mt-24',
  'lg:mt-104': 'lg:mt-[6.5rem]',
  'lg:mt-105': 'lg:mt-[105px]',
  'lg:mt-112': 'lg:mt-28',
  'lg:mt-120': 'lg:mt-[7.5rem]',
  'lg:mt-128': 'lg:mt-32',
  'lg:mt-156': 'lg:mt-[9.75rem]',
  'lg:mt-170': 'lg:mt-[10.625rem]',
  'lg:mt-220': 'lg:mt-[13.75rem]',
  'lg:mt-270': 'lg:mt-[16.875rem]',
  'lg:mt-340': 'lg:mt-[21.25rem]',
  'lg:mt-460': 'lg:mt-[28.75rem]',
  'lg:mb-auto': 'lg:mb-auto',
  'lg:mb-0': 'lg:mb-0',
  'lg:mb-2': 'lg:mb-0.5',
  'lg:mb-4': 'lg:mb-1',
  'lg:mb-6': 'lg:mb-1.5',
  'lg:mb-8': 'lg:mb-2',
  'lg:mb-10': 'lg:mb-2.5',
  'lg:mb-12': 'lg:mb-3',
  'lg:mb-16': 'lg:mb-4',
  'lg:mb-20': 'lg:mb-5',
  'lg:mb-24': 'lg:mb-6',
  'lg:mb-28': 'lg:mb-7',
  'lg:mb-32': 'lg:mb-8',
  'lg:mb-36': 'lg:mb-9',
  'lg:mb-40': 'lg:mb-10',
  'lg:mb-44': 'lg:mb-11',
  'lg:mb-48': 'lg:mb-12',
  'lg:mb-54': 'lg:mb-[3.25rem]',
  'lg:mb-55': 'lg:mb-[55px]',
  'lg:mb-56': 'lg:mb-14',
  'lg:mb-60': 'lg:mb-[3.75rem]',
  'lg:mb-64': 'lg:mb-16',
  'lg:mb-72': 'lg:mb-[4.5rem]',
  'lg:mb-80': 'lg:mb-20',
  'lg:mb-88': 'lg:mb-[5.5rem]',
  'lg:mb-96': 'lg:mb-24',
  'lg:mb-104': 'lg:mb-[6.5rem]',
  'lg:mb-105': 'lg:mb-[105px]',
  'lg:mb-112': 'lg:mb-28',
  'lg:mb-120': 'lg:mb-[7.5rem]',
  'lg:mb-128': 'lg:mb-32',
  'lg:mb-156': 'lg:mb-[9.75rem]',
  'lg:mb-170': 'lg:mb-[10.625rem]',
  'lg:mb-220': 'lg:mb-[13.75rem]',
  'lg:mb-270': 'lg:mb-[16.875rem]',
  'lg:mb-340': 'lg:mb-[21.25rem]',
  'lg:mb-460': 'lg:mb-[28.75rem]',
  'lg:ml-auto': 'lg:ml-auto',
  'lg:ml-0': 'lg:ml-0',
  'lg:ml-2': 'lg:ml-0.5',
  'lg:ml-4': 'lg:ml-1',
  'lg:ml-6': 'lg:ml-1.5',
  'lg:ml-8': 'lg:ml-2',
  'lg:ml-10': 'lg:ml-2.5',
  'lg:ml-12': 'lg:ml-3',
  'lg:ml-16': 'lg:ml-4',
  'lg:ml-20': 'lg:ml-5',
  'lg:ml-24': 'lg:ml-6',
  'lg:ml-28': 'lg:ml-7',
  'lg:ml-32': 'lg:ml-8',
  'lg:ml-36': 'lg:ml-9',
  'lg:ml-40': 'lg:ml-10',
  'lg:ml-44': 'lg:ml-11',
  'lg:ml-48': 'lg:ml-12',
  'lg:ml-54': 'lg:ml-[3.25rem]',
  'lg:ml-55': 'lg:ml-[55px]',
  'lg:ml-56': 'lg:ml-14',
  'lg:ml-60': 'lg:ml-[3.75rem]',
  'lg:ml-64': 'lg:ml-16',
  'lg:ml-72': 'lg:ml-[4.5rem]',
  'lg:ml-80': 'lg:ml-20',
  'lg:ml-88': 'lg:ml-[5.5rem]',
  'lg:ml-96': 'lg:ml-24',
  'lg:ml-104': 'lg:ml-[6.5rem]',
  'lg:ml-105': 'lg:ml-[105px]',
  'lg:ml-112': 'lg:ml-28',
  'lg:ml-120': 'lg:ml-[7.5rem]',
  'lg:ml-128': 'lg:ml-32',
  'lg:ml-156': 'lg:ml-[9.75rem]',
  'lg:ml-170': 'lg:ml-[10.625rem]',
  'lg:ml-220': 'lg:ml-[13.75rem]',
  'lg:ml-270': 'lg:ml-[16.875rem]',
  'lg:ml-340': 'lg:ml-[21.25rem]',
  'lg:ml-460': 'lg:ml-[28.75rem]',
  'lg:mr-auto': 'lg:mr-auto',
  'lg:mr-0': 'lg:mr-0',
  'lg:mr-2': 'lg:mr-0.5',
  'lg:mr-4': 'lg:mr-1',
  'lg:mr-6': 'lg:mr-1.5',
  'lg:mr-8': 'lg:mr-2',
  'lg:mr-10': 'lg:mr-2.5',
  'lg:mr-12': 'lg:mr-3',
  'lg:mr-16': 'lg:mr-4',
  'lg:mr-20': 'lg:mr-5',
  'lg:mr-24': 'lg:mr-6',
  'lg:mr-28': 'lg:mr-7',
  'lg:mr-32': 'lg:mr-8',
  'lg:mr-36': 'lg:mr-9',
  'lg:mr-40': 'lg:mr-10',
  'lg:mr-44': 'lg:mr-11',
  'lg:mr-48': 'lg:mr-12',
  'lg:mr-54': 'lg:mr-[3.25rem]',
  'lg:mr-55': 'lg:mr-[55px]',
  'lg:mr-56': 'lg:mr-14',
  'lg:mr-60': 'lg:mr-[3.75rem]',
  'lg:mr-64': 'lg:mr-16',
  'lg:mr-72': 'lg:mr-[4.5rem]',
  'lg:mr-80': 'lg:mr-20',
  'lg:mr-88': 'lg:mr-[5.5rem]',
  'lg:mr-96': 'lg:mr-24',
  'lg:mr-104': 'lg:mr-[6.5rem]',
  'lg:mr-105': 'lg:mr-[105px]',
  'lg:mr-112': 'lg:mr-28',
  'lg:mr-120': 'lg:mr-[7.5rem]',
  'lg:mr-128': 'lg:mr-32',
  'lg:mr-156': 'lg:mr-[9.75rem]',
  'lg:mr-170': 'lg:mr-[10.625rem]',
  'lg:mr-220': 'lg:mr-[13.75rem]',
  'lg:mr-270': 'lg:mr-[16.875rem]',
  'lg:mr-340': 'lg:mr-[21.25rem]',
  'lg:mr-460': 'lg:mr-[28.75rem]',
  'lg:mx-auto': 'lg:mx-auto',
  'lg:mx-0': 'lg:mx-0',
  'lg:mx-2': 'lg:mx-0.5',
  'lg:mx-4': 'lg:mx-1',
  'lg:mx-6': 'lg:mx-1.5',
  'lg:mx-8': 'lg:mx-2',
  'lg:mx-10': 'lg:mx-2.5',
  'lg:mx-12': 'lg:mx-3',
  'lg:mx-16': 'lg:mx-4',
  'lg:mx-20': 'lg:mx-5',
  'lg:mx-24': 'lg:mx-6',
  'lg:mx-28': 'lg:mx-7',
  'lg:mx-32': 'lg:mx-8',
  'lg:mx-36': 'lg:mx-9',
  'lg:mx-40': 'lg:mx-10',
  'lg:mx-44': 'lg:mx-11',
  'lg:mx-48': 'lg:mx-12',
  'lg:mx-54': 'lg:mx-[3.25rem]',
  'lg:mx-55': 'lg:mx-[55px]',
  'lg:mx-56': 'lg:mx-14',
  'lg:mx-60': 'lg:mx-[3.75rem]',
  'lg:mx-64': 'lg:mx-16',
  'lg:mx-72': 'lg:mx-[4.5rem]',
  'lg:mx-80': 'lg:mx-20',
  'lg:mx-88': 'lg:mx-[5.5rem]',
  'lg:mx-96': 'lg:mx-24',
  'lg:mx-104': 'lg:mx-[6.5rem]',
  'lg:mx-105': 'lg:mx-[105px]',
  'lg:mx-112': 'lg:mx-28',
  'lg:mx-120': 'lg:mx-[7.5rem]',
  'lg:mx-128': 'lg:mx-32',
  'lg:mx-156': 'lg:mx-[9.75rem]',
  'lg:mx-170': 'lg:mx-[10.625rem]',
  'lg:mx-220': 'lg:mx-[13.75rem]',
  'lg:mx-270': 'lg:mx-[16.875rem]',
  'lg:mx-340': 'lg:mx-[21.25rem]',
  'lg:mx-460': 'lg:mx-[28.75rem]',
  'lg:my-auto': 'lg:my-auto',
  'lg:my-0': 'lg:my-0',
  'lg:my-2': 'lg:my-0.5',
  'lg:my-4': 'lg:my-1',
  'lg:my-6': 'lg:my-1.5',
  'lg:my-8': 'lg:my-2',
  'lg:my-10': 'lg:my-2.5',
  'lg:my-12': 'lg:my-3',
  'lg:my-16': 'lg:my-4',
  'lg:my-20': 'lg:my-5',
  'lg:my-24': 'lg:my-6',
  'lg:my-28': 'lg:my-7',
  'lg:my-32': 'lg:my-8',
  'lg:my-36': 'lg:my-9',
  'lg:my-40': 'lg:my-10',
  'lg:my-44': 'lg:my-11',
  'lg:my-48': 'lg:my-12',
  'lg:my-54': 'lg:my-[3.25rem]',
  'lg:my-55': 'lg:my-[55px]',
  'lg:my-56': 'lg:my-14',
  'lg:my-60': 'lg:my-[3.75rem]',
  'lg:my-64': 'lg:my-16',
  'lg:my-72': 'lg:my-[4.5rem]',
  'lg:my-80': 'lg:my-20',
  'lg:my-88': 'lg:my-[5.5rem]',
  'lg:my-96': 'lg:my-24',
  'lg:my-104': 'lg:my-[6.5rem]',
  'lg:my-105': 'lg:my-[105px]',
  'lg:my-112': 'lg:my-28',
  'lg:my-120': 'lg:my-[7.5rem]',
  'lg:my-128': 'lg:my-32',
  'lg:my-156': 'lg:my-[9.75rem]',
  'lg:my-170': 'lg:my-[10.625rem]',
  'lg:my-220': 'lg:my-[13.75rem]',
  'lg:my-270': 'lg:my-[16.875rem]',
  'lg:my-340': 'lg:my-[21.25rem]',
  'lg:my-460': 'lg:my-[28.75rem]',
  'xl:m-auto': 'xl:m-auto',
  'xl:m-0': 'xl:m-0',
  'xl:m-2': 'xl:m-0.5',
  'xl:m-4': 'xl:m-1',
  'xl:m-6': 'xl:m-1.5',
  'xl:m-8': 'xl:m-2',
  'xl:m-10': 'xl:m-2.5',
  'xl:m-12': 'xl:m-3',
  'xl:m-16': 'xl:m-4',
  'xl:m-20': 'xl:m-5',
  'xl:m-24': 'xl:m-6',
  'xl:m-28': 'xl:m-7',
  'xl:m-32': 'xl:m-8',
  'xl:m-36': 'xl:m-9',
  'xl:m-40': 'xl:m-10',
  'xl:m-44': 'xl:m-11',
  'xl:m-48': 'xl:m-12',
  'xl:m-54': 'xl:m-[3.25rem]',
  'xl:m-55': 'xl:m-[55px]',
  'xl:m-56': 'xl:m-14',
  'xl:m-60': 'xl:m-[3.75rem]',
  'xl:m-64': 'xl:m-16',
  'xl:m-72': 'xl:m-[4.5rem]',
  'xl:m-80': 'xl:m-20',
  'xl:m-88': 'xl:m-[5.5rem]',
  'xl:m-96': 'xl:m-24',
  'xl:m-104': 'xl:m-[6.5rem]',
  'xl:m-105': 'xl:m-[105px]',
  'xl:m-112': 'xl:m-28',
  'xl:m-120': 'xl:m-[7.5rem]',
  'xl:m-128': 'xl:m-32',
  'xl:m-156': 'xl:m-[9.75rem]',
  'xl:m-170': 'xl:m-[10.625rem]',
  'xl:m-220': 'xl:m-[13.75rem]',
  'xl:m-270': 'xl:m-[16.875rem]',
  'xl:m-340': 'xl:m-[21.25rem]',
  'xl:m-460': 'xl:m-[28.75rem]',
  'xl:mt-auto': 'xl:mt-auto',
  'xl:mt-0': 'xl:mt-0',
  'xl:mt-2': 'xl:mt-0.5',
  'xl:mt-4': 'xl:mt-1',
  'xl:mt-6': 'xl:mt-1.5',
  'xl:mt-8': 'xl:mt-2',
  'xl:mt-10': 'xl:mt-2.5',
  'xl:mt-12': 'xl:mt-3',
  'xl:mt-16': 'xl:mt-4',
  'xl:mt-20': 'xl:mt-5',
  'xl:mt-24': 'xl:mt-6',
  'xl:mt-28': 'xl:mt-7',
  'xl:mt-32': 'xl:mt-8',
  'xl:mt-36': 'xl:mt-9',
  'xl:mt-40': 'xl:mt-10',
  'xl:mt-44': 'xl:mt-11',
  'xl:mt-48': 'xl:mt-12',
  'xl:mt-54': 'xl:mt-[3.25rem]',
  'xl:mt-55': 'xl:mt-[55px]',
  'xl:mt-56': 'xl:mt-14',
  'xl:mt-60': 'xl:mt-[3.75rem]',
  'xl:mt-64': 'xl:mt-16',
  'xl:mt-72': 'xl:mt-[4.5rem]',
  'xl:mt-80': 'xl:mt-20',
  'xl:mt-88': 'xl:mt-[5.5rem]',
  'xl:mt-96': 'xl:mt-24',
  'xl:mt-104': 'xl:mt-[6.5rem]',
  'xl:mt-105': 'xl:mt-[105px]',
  'xl:mt-112': 'xl:mt-28',
  'xl:mt-120': 'xl:mt-[7.5rem]',
  'xl:mt-128': 'xl:mt-32',
  'xl:mt-156': 'xl:mt-[9.75rem]',
  'xl:mt-170': 'xl:mt-[10.625rem]',
  'xl:mt-220': 'xl:mt-[13.75rem]',
  'xl:mt-270': 'xl:mt-[16.875rem]',
  'xl:mt-340': 'xl:mt-[21.25rem]',
  'xl:mt-460': 'xl:mt-[28.75rem]',
  'xl:mb-auto': 'xl:mb-auto',
  'xl:mb-0': 'xl:mb-0',
  'xl:mb-2': 'xl:mb-0.5',
  'xl:mb-4': 'xl:mb-1',
  'xl:mb-6': 'xl:mb-1.5',
  'xl:mb-8': 'xl:mb-2',
  'xl:mb-10': 'xl:mb-2.5',
  'xl:mb-12': 'xl:mb-3',
  'xl:mb-16': 'xl:mb-4',
  'xl:mb-20': 'xl:mb-5',
  'xl:mb-24': 'xl:mb-6',
  'xl:mb-28': 'xl:mb-7',
  'xl:mb-32': 'xl:mb-8',
  'xl:mb-36': 'xl:mb-9',
  'xl:mb-40': 'xl:mb-10',
  'xl:mb-44': 'xl:mb-11',
  'xl:mb-48': 'xl:mb-12',
  'xl:mb-54': 'xl:mb-[3.25rem]',
  'xl:mb-55': 'xl:mb-[55px]',
  'xl:mb-56': 'xl:mb-14',
  'xl:mb-60': 'xl:mb-[3.75rem]',
  'xl:mb-64': 'xl:mb-16',
  'xl:mb-72': 'xl:mb-[4.5rem]',
  'xl:mb-80': 'xl:mb-20',
  'xl:mb-88': 'xl:mb-[5.5rem]',
  'xl:mb-96': 'xl:mb-24',
  'xl:mb-104': 'xl:mb-[6.5rem]',
  'xl:mb-105': 'xl:mb-[105px]',
  'xl:mb-112': 'xl:mb-28',
  'xl:mb-120': 'xl:mb-[7.5rem]',
  'xl:mb-128': 'xl:mb-32',
  'xl:mb-156': 'xl:mb-[9.75rem]',
  'xl:mb-170': 'xl:mb-[10.625rem]',
  'xl:mb-220': 'xl:mb-[13.75rem]',
  'xl:mb-270': 'xl:mb-[16.875rem]',
  'xl:mb-340': 'xl:mb-[21.25rem]',
  'xl:mb-460': 'xl:mb-[28.75rem]',
  'xl:ml-auto': 'xl:ml-auto',
  'xl:ml-0': 'xl:ml-0',
  'xl:ml-2': 'xl:ml-0.5',
  'xl:ml-4': 'xl:ml-1',
  'xl:ml-6': 'xl:ml-1.5',
  'xl:ml-8': 'xl:ml-2',
  'xl:ml-10': 'xl:ml-2.5',
  'xl:ml-12': 'xl:ml-3',
  'xl:ml-16': 'xl:ml-4',
  'xl:ml-20': 'xl:ml-5',
  'xl:ml-24': 'xl:ml-6',
  'xl:ml-28': 'xl:ml-7',
  'xl:ml-32': 'xl:ml-8',
  'xl:ml-36': 'xl:ml-9',
  'xl:ml-40': 'xl:ml-10',
  'xl:ml-44': 'xl:ml-11',
  'xl:ml-48': 'xl:ml-12',
  'xl:ml-54': 'xl:ml-[3.25rem]',
  'xl:ml-55': 'xl:ml-[55px]',
  'xl:ml-56': 'xl:ml-14',
  'xl:ml-60': 'xl:ml-[3.75rem]',
  'xl:ml-64': 'xl:ml-16',
  'xl:ml-72': 'xl:ml-[4.5rem]',
  'xl:ml-80': 'xl:ml-20',
  'xl:ml-88': 'xl:ml-[5.5rem]',
  'xl:ml-96': 'xl:ml-24',
  'xl:ml-104': 'xl:ml-[6.5rem]',
  'xl:ml-105': 'xl:ml-[105px]',
  'xl:ml-112': 'xl:ml-28',
  'xl:ml-120': 'xl:ml-[7.5rem]',
  'xl:ml-128': 'xl:ml-32',
  'xl:ml-156': 'xl:ml-[9.75rem]',
  'xl:ml-170': 'xl:ml-[10.625rem]',
  'xl:ml-220': 'xl:ml-[13.75rem]',
  'xl:ml-270': 'xl:ml-[16.875rem]',
  'xl:ml-340': 'xl:ml-[21.25rem]',
  'xl:ml-460': 'xl:ml-[28.75rem]',
  'xl:mr-auto': 'xl:mr-auto',
  'xl:mr-0': 'xl:mr-0',
  'xl:mr-2': 'xl:mr-0.5',
  'xl:mr-4': 'xl:mr-1',
  'xl:mr-6': 'xl:mr-1.5',
  'xl:mr-8': 'xl:mr-2',
  'xl:mr-10': 'xl:mr-2.5',
  'xl:mr-12': 'xl:mr-3',
  'xl:mr-16': 'xl:mr-4',
  'xl:mr-20': 'xl:mr-5',
  'xl:mr-24': 'xl:mr-6',
  'xl:mr-28': 'xl:mr-7',
  'xl:mr-32': 'xl:mr-8',
  'xl:mr-36': 'xl:mr-9',
  'xl:mr-40': 'xl:mr-10',
  'xl:mr-44': 'xl:mr-11',
  'xl:mr-48': 'xl:mr-12',
  'xl:mr-54': 'xl:mr-[3.25rem]',
  'xl:mr-55': 'xl:mr-[55px]',
  'xl:mr-56': 'xl:mr-14',
  'xl:mr-60': 'xl:mr-[3.75rem]',
  'xl:mr-64': 'xl:mr-16',
  'xl:mr-72': 'xl:mr-[4.5rem]',
  'xl:mr-80': 'xl:mr-20',
  'xl:mr-88': 'xl:mr-[5.5rem]',
  'xl:mr-96': 'xl:mr-24',
  'xl:mr-104': 'xl:mr-[6.5rem]',
  'xl:mr-105': 'xl:mr-[105px]',
  'xl:mr-112': 'xl:mr-28',
  'xl:mr-120': 'xl:mr-[7.5rem]',
  'xl:mr-128': 'xl:mr-32',
  'xl:mr-156': 'xl:mr-[9.75rem]',
  'xl:mr-170': 'xl:mr-[10.625rem]',
  'xl:mr-220': 'xl:mr-[13.75rem]',
  'xl:mr-270': 'xl:mr-[16.875rem]',
  'xl:mr-340': 'xl:mr-[21.25rem]',
  'xl:mr-460': 'xl:mr-[28.75rem]',
  'xl:mx-auto': 'xl:mx-auto',
  'xl:mx-0': 'xl:mx-0',
  'xl:mx-2': 'xl:mx-0.5',
  'xl:mx-4': 'xl:mx-1',
  'xl:mx-6': 'xl:mx-1.5',
  'xl:mx-8': 'xl:mx-2',
  'xl:mx-10': 'xl:mx-2.5',
  'xl:mx-12': 'xl:mx-3',
  'xl:mx-16': 'xl:mx-4',
  'xl:mx-20': 'xl:mx-5',
  'xl:mx-24': 'xl:mx-6',
  'xl:mx-28': 'xl:mx-7',
  'xl:mx-32': 'xl:mx-8',
  'xl:mx-36': 'xl:mx-9',
  'xl:mx-40': 'xl:mx-10',
  'xl:mx-44': 'xl:mx-11',
  'xl:mx-48': 'xl:mx-12',
  'xl:mx-54': 'xl:mx-[3.25rem]',
  'xl:mx-55': 'xl:mx-[55px]',
  'xl:mx-56': 'xl:mx-14',
  'xl:mx-60': 'xl:mx-[3.75rem]',
  'xl:mx-64': 'xl:mx-16',
  'xl:mx-72': 'xl:mx-[4.5rem]',
  'xl:mx-80': 'xl:mx-20',
  'xl:mx-88': 'xl:mx-[5.5rem]',
  'xl:mx-96': 'xl:mx-24',
  'xl:mx-104': 'xl:mx-[6.5rem]',
  'xl:mx-105': 'xl:mx-[105px]',
  'xl:mx-112': 'xl:mx-28',
  'xl:mx-120': 'xl:mx-[7.5rem]',
  'xl:mx-128': 'xl:mx-32',
  'xl:mx-156': 'xl:mx-[9.75rem]',
  'xl:mx-170': 'xl:mx-[10.625rem]',
  'xl:mx-220': 'xl:mx-[13.75rem]',
  'xl:mx-270': 'xl:mx-[16.875rem]',
  'xl:mx-340': 'xl:mx-[21.25rem]',
  'xl:mx-460': 'xl:mx-[28.75rem]',
  'xl:my-auto': 'xl:my-auto',
  'xl:my-0': 'xl:my-0',
  'xl:my-2': 'xl:my-0.5',
  'xl:my-4': 'xl:my-1',
  'xl:my-6': 'xl:my-1.5',
  'xl:my-8': 'xl:my-2',
  'xl:my-10': 'xl:my-2.5',
  'xl:my-12': 'xl:my-3',
  'xl:my-16': 'xl:my-4',
  'xl:my-20': 'xl:my-5',
  'xl:my-24': 'xl:my-6',
  'xl:my-28': 'xl:my-7',
  'xl:my-32': 'xl:my-8',
  'xl:my-36': 'xl:my-9',
  'xl:my-40': 'xl:my-10',
  'xl:my-44': 'xl:my-11',
  'xl:my-48': 'xl:my-12',
  'xl:my-54': 'xl:my-[3.25rem]',
  'xl:my-55': 'xl:my-[55px]',
  'xl:my-56': 'xl:my-14',
  'xl:my-60': 'xl:my-[3.75rem]',
  'xl:my-64': 'xl:my-16',
  'xl:my-72': 'xl:my-[4.5rem]',
  'xl:my-80': 'xl:my-20',
  'xl:my-88': 'xl:my-[5.5rem]',
  'xl:my-96': 'xl:my-24',
  'xl:my-104': 'xl:my-[6.5rem]',
  'xl:my-105': 'xl:my-[105px]',
  'xl:my-112': 'xl:my-28',
  'xl:my-120': 'xl:my-[7.5rem]',
  'xl:my-128': 'xl:my-32',
  'xl:my-156': 'xl:my-[9.75rem]',
  'xl:my-170': 'xl:my-[10.625rem]',
  'xl:my-220': 'xl:my-[13.75rem]',
  'xl:my-270': 'xl:my-[16.875rem]',
  'xl:my-340': 'xl:my-[21.25rem]',
  'xl:my-460': 'xl:my-[28.75rem]',
  'xxl:m-auto': '2xl:m-auto',
  'xxl:m-0': '2xl:m-0',
  'xxl:m-2': '2xl:m-0.5',
  'xxl:m-4': '2xl:m-1',
  'xxl:m-6': '2xl:m-1.5',
  'xxl:m-8': '2xl:m-2',
  'xxl:m-10': '2xl:m-2.5',
  'xxl:m-12': '2xl:m-3',
  'xxl:m-16': '2xl:m-4',
  'xxl:m-20': '2xl:m-5',
  'xxl:m-24': '2xl:m-6',
  'xxl:m-28': '2xl:m-7',
  'xxl:m-32': '2xl:m-8',
  'xxl:m-36': '2xl:m-9',
  'xxl:m-40': '2xl:m-10',
  'xxl:m-44': '2xl:m-11',
  'xxl:m-48': '2xl:m-12',
  'xxl:m-54': '2xl:m-[3.25rem]',
  'xxl:m-55': '2xl:m-[55px]',
  'xxl:m-56': '2xl:m-14',
  'xxl:m-60': '2xl:m-[3.75rem]',
  'xxl:m-64': '2xl:m-16',
  'xxl:m-72': '2xl:m-[4.5rem]',
  'xxl:m-80': '2xl:m-20',
  'xxl:m-88': '2xl:m-[5.5rem]',
  'xxl:m-96': '2xl:m-24',
  'xxl:m-104': '2xl:m-[6.5rem]',
  'xxl:m-105': '2xl:m-[105px]',
  'xxl:m-112': '2xl:m-28',
  'xxl:m-120': '2xl:m-[7.5rem]',
  'xxl:m-128': '2xl:m-32',
  'xxl:m-156': '2xl:m-[9.75rem]',
  'xxl:m-170': '2xl:m-[10.625rem]',
  'xxl:m-220': '2xl:m-[13.75rem]',
  'xxl:m-270': '2xl:m-[16.875rem]',
  'xxl:m-340': '2xl:m-[21.25rem]',
  'xxl:m-460': '2xl:m-[28.75rem]',
  'xxl:mt-auto': '2xl:mt-auto',
  'xxl:mt-0': '2xl:mt-0',
  'xxl:mt-2': '2xl:mt-0.5',
  'xxl:mt-4': '2xl:mt-1',
  'xxl:mt-6': '2xl:mt-1.5',
  'xxl:mt-8': '2xl:mt-2',
  'xxl:mt-10': '2xl:mt-2.5',
  'xxl:mt-12': '2xl:mt-3',
  'xxl:mt-16': '2xl:mt-4',
  'xxl:mt-20': '2xl:mt-5',
  'xxl:mt-24': '2xl:mt-6',
  'xxl:mt-28': '2xl:mt-7',
  'xxl:mt-32': '2xl:mt-8',
  'xxl:mt-36': '2xl:mt-9',
  'xxl:mt-40': '2xl:mt-10',
  'xxl:mt-44': '2xl:mt-11',
  'xxl:mt-48': '2xl:mt-12',
  'xxl:mt-54': '2xl:mt-[3.25rem]',
  'xxl:mt-55': '2xl:mt-[55px]',
  'xxl:mt-56': '2xl:mt-14',
  'xxl:mt-60': '2xl:mt-[3.75rem]',
  'xxl:mt-64': '2xl:mt-16',
  'xxl:mt-72': '2xl:mt-[4.5rem]',
  'xxl:mt-80': '2xl:mt-20',
  'xxl:mt-88': '2xl:mt-[5.5rem]',
  'xxl:mt-96': '2xl:mt-24',
  'xxl:mt-104': '2xl:mt-[6.5rem]',
  'xxl:mt-105': '2xl:mt-[105px]',
  'xxl:mt-112': '2xl:mt-28',
  'xxl:mt-120': '2xl:mt-[7.5rem]',
  'xxl:mt-128': '2xl:mt-32',
  'xxl:mt-156': '2xl:mt-[9.75rem]',
  'xxl:mt-170': '2xl:mt-[10.625rem]',
  'xxl:mt-220': '2xl:mt-[13.75rem]',
  'xxl:mt-270': '2xl:mt-[16.875rem]',
  'xxl:mt-340': '2xl:mt-[21.25rem]',
  'xxl:mt-460': '2xl:mt-[28.75rem]',
  'xxl:mb-auto': '2xl:mb-auto',
  'xxl:mb-0': '2xl:mb-0',
  'xxl:mb-2': '2xl:mb-0.5',
  'xxl:mb-4': '2xl:mb-1',
  'xxl:mb-6': '2xl:mb-1.5',
  'xxl:mb-8': '2xl:mb-2',
  'xxl:mb-10': '2xl:mb-2.5',
  'xxl:mb-12': '2xl:mb-3',
  'xxl:mb-16': '2xl:mb-4',
  'xxl:mb-20': '2xl:mb-5',
  'xxl:mb-24': '2xl:mb-6',
  'xxl:mb-28': '2xl:mb-7',
  'xxl:mb-32': '2xl:mb-8',
  'xxl:mb-36': '2xl:mb-9',
  'xxl:mb-40': '2xl:mb-10',
  'xxl:mb-44': '2xl:mb-11',
  'xxl:mb-48': '2xl:mb-12',
  'xxl:mb-54': '2xl:mb-[3.25rem]',
  'xxl:mb-55': '2xl:mb-[55px]',
  'xxl:mb-56': '2xl:mb-14',
  'xxl:mb-60': '2xl:mb-[3.75rem]',
  'xxl:mb-64': '2xl:mb-16',
  'xxl:mb-72': '2xl:mb-[4.5rem]',
  'xxl:mb-80': '2xl:mb-20',
  'xxl:mb-88': '2xl:mb-[5.5rem]',
  'xxl:mb-96': '2xl:mb-24',
  'xxl:mb-104': '2xl:mb-[6.5rem]',
  'xxl:mb-105': '2xl:mb-[105px]',
  'xxl:mb-112': '2xl:mb-28',
  'xxl:mb-120': '2xl:mb-[7.5rem]',
  'xxl:mb-128': '2xl:mb-32',
  'xxl:mb-156': '2xl:mb-[9.75rem]',
  'xxl:mb-170': '2xl:mb-[10.625rem]',
  'xxl:mb-220': '2xl:mb-[13.75rem]',
  'xxl:mb-270': '2xl:mb-[16.875rem]',
  'xxl:mb-340': '2xl:mb-[21.25rem]',
  'xxl:mb-460': '2xl:mb-[28.75rem]',
  'xxl:ml-auto': '2xl:ml-auto',
  'xxl:ml-0': '2xl:ml-0',
  'xxl:ml-2': '2xl:ml-0.5',
  'xxl:ml-4': '2xl:ml-1',
  'xxl:ml-6': '2xl:ml-1.5',
  'xxl:ml-8': '2xl:ml-2',
  'xxl:ml-10': '2xl:ml-2.5',
  'xxl:ml-12': '2xl:ml-3',
  'xxl:ml-16': '2xl:ml-4',
  'xxl:ml-20': '2xl:ml-5',
  'xxl:ml-24': '2xl:ml-6',
  'xxl:ml-28': '2xl:ml-7',
  'xxl:ml-32': '2xl:ml-8',
  'xxl:ml-36': '2xl:ml-9',
  'xxl:ml-40': '2xl:ml-10',
  'xxl:ml-44': '2xl:ml-11',
  'xxl:ml-48': '2xl:ml-12',
  'xxl:ml-54': '2xl:ml-[3.25rem]',
  'xxl:ml-55': '2xl:ml-[55px]',
  'xxl:ml-56': '2xl:ml-14',
  'xxl:ml-60': '2xl:ml-[3.75rem]',
  'xxl:ml-64': '2xl:ml-16',
  'xxl:ml-72': '2xl:ml-[4.5rem]',
  'xxl:ml-80': '2xl:ml-20',
  'xxl:ml-88': '2xl:ml-[5.5rem]',
  'xxl:ml-96': '2xl:ml-24',
  'xxl:ml-104': '2xl:ml-[6.5rem]',
  'xxl:ml-105': '2xl:ml-[105px]',
  'xxl:ml-112': '2xl:ml-28',
  'xxl:ml-120': '2xl:ml-[7.5rem]',
  'xxl:ml-128': '2xl:ml-32',
  'xxl:ml-156': '2xl:ml-[9.75rem]',
  'xxl:ml-170': '2xl:ml-[10.625rem]',
  'xxl:ml-220': '2xl:ml-[13.75rem]',
  'xxl:ml-270': '2xl:ml-[16.875rem]',
  'xxl:ml-340': '2xl:ml-[21.25rem]',
  'xxl:ml-460': '2xl:ml-[28.75rem]',
  'xxl:mr-auto': '2xl:mr-auto',
  'xxl:mr-0': '2xl:mr-0',
  'xxl:mr-2': '2xl:mr-0.5',
  'xxl:mr-4': '2xl:mr-1',
  'xxl:mr-6': '2xl:mr-1.5',
  'xxl:mr-8': '2xl:mr-2',
  'xxl:mr-10': '2xl:mr-2.5',
  'xxl:mr-12': '2xl:mr-3',
  'xxl:mr-16': '2xl:mr-4',
  'xxl:mr-20': '2xl:mr-5',
  'xxl:mr-24': '2xl:mr-6',
  'xxl:mr-28': '2xl:mr-7',
  'xxl:mr-32': '2xl:mr-8',
  'xxl:mr-36': '2xl:mr-9',
  'xxl:mr-40': '2xl:mr-10',
  'xxl:mr-44': '2xl:mr-11',
  'xxl:mr-48': '2xl:mr-12',
  'xxl:mr-54': '2xl:mr-[3.25rem]',
  'xxl:mr-55': '2xl:mr-[55px]',
  'xxl:mr-56': '2xl:mr-14',
  'xxl:mr-60': '2xl:mr-[3.75rem]',
  'xxl:mr-64': '2xl:mr-16',
  'xxl:mr-72': '2xl:mr-[4.5rem]',
  'xxl:mr-80': '2xl:mr-20',
  'xxl:mr-88': '2xl:mr-[5.5rem]',
  'xxl:mr-96': '2xl:mr-24',
  'xxl:mr-104': '2xl:mr-[6.5rem]',
  'xxl:mr-105': '2xl:mr-[105px]',
  'xxl:mr-112': '2xl:mr-28',
  'xxl:mr-120': '2xl:mr-[7.5rem]',
  'xxl:mr-128': '2xl:mr-32',
  'xxl:mr-156': '2xl:mr-[9.75rem]',
  'xxl:mr-170': '2xl:mr-[10.625rem]',
  'xxl:mr-220': '2xl:mr-[13.75rem]',
  'xxl:mr-270': '2xl:mr-[16.875rem]',
  'xxl:mr-340': '2xl:mr-[21.25rem]',
  'xxl:mr-460': '2xl:mr-[28.75rem]',
  'xxl:mx-auto': '2xl:mx-auto',
  'xxl:mx-0': '2xl:mx-0',
  'xxl:mx-2': '2xl:mx-0.5',
  'xxl:mx-4': '2xl:mx-1',
  'xxl:mx-6': '2xl:mx-1.5',
  'xxl:mx-8': '2xl:mx-2',
  'xxl:mx-10': '2xl:mx-2.5',
  'xxl:mx-12': '2xl:mx-3',
  'xxl:mx-16': '2xl:mx-4',
  'xxl:mx-20': '2xl:mx-5',
  'xxl:mx-24': '2xl:mx-6',
  'xxl:mx-28': '2xl:mx-7',
  'xxl:mx-32': '2xl:mx-8',
  'xxl:mx-36': '2xl:mx-9',
  'xxl:mx-40': '2xl:mx-10',
  'xxl:mx-44': '2xl:mx-11',
  'xxl:mx-48': '2xl:mx-12',
  'xxl:mx-54': '2xl:mx-[3.25rem]',
  'xxl:mx-55': '2xl:mx-[55px]',
  'xxl:mx-56': '2xl:mx-14',
  'xxl:mx-60': '2xl:mx-[3.75rem]',
  'xxl:mx-64': '2xl:mx-16',
  'xxl:mx-72': '2xl:mx-[4.5rem]',
  'xxl:mx-80': '2xl:mx-20',
  'xxl:mx-88': '2xl:mx-[5.5rem]',
  'xxl:mx-96': '2xl:mx-24',
  'xxl:mx-104': '2xl:mx-[6.5rem]',
  'xxl:mx-105': '2xl:mx-[105px]',
  'xxl:mx-112': '2xl:mx-28',
  'xxl:mx-120': '2xl:mx-[7.5rem]',
  'xxl:mx-128': '2xl:mx-32',
  'xxl:mx-156': '2xl:mx-[9.75rem]',
  'xxl:mx-170': '2xl:mx-[10.625rem]',
  'xxl:mx-220': '2xl:mx-[13.75rem]',
  'xxl:mx-270': '2xl:mx-[16.875rem]',
  'xxl:mx-340': '2xl:mx-[21.25rem]',
  'xxl:mx-460': '2xl:mx-[28.75rem]',
  'xxl:my-auto': '2xl:my-auto',
  'xxl:my-0': '2xl:my-0',
  'xxl:my-2': '2xl:my-0.5',
  'xxl:my-4': '2xl:my-1',
  'xxl:my-6': '2xl:my-1.5',
  'xxl:my-8': '2xl:my-2',
  'xxl:my-10': '2xl:my-2.5',
  'xxl:my-12': '2xl:my-3',
  'xxl:my-16': '2xl:my-4',
  'xxl:my-20': '2xl:my-5',
  'xxl:my-24': '2xl:my-6',
  'xxl:my-28': '2xl:my-7',
  'xxl:my-32': '2xl:my-8',
  'xxl:my-36': '2xl:my-9',
  'xxl:my-40': '2xl:my-10',
  'xxl:my-44': '2xl:my-11',
  'xxl:my-48': '2xl:my-12',
  'xxl:my-54': '2xl:my-[3.25rem]',
  'xxl:my-55': '2xl:my-[55px]',
  'xxl:my-56': '2xl:my-14',
  'xxl:my-60': '2xl:my-[3.75rem]',
  'xxl:my-64': '2xl:my-16',
  'xxl:my-72': '2xl:my-[4.5rem]',
  'xxl:my-80': '2xl:my-20',
  'xxl:my-88': '2xl:my-[5.5rem]',
  'xxl:my-96': '2xl:my-24',
  'xxl:my-104': '2xl:my-[6.5rem]',
  'xxl:my-105': '2xl:my-[105px]',
  'xxl:my-112': '2xl:my-28',
  'xxl:my-120': '2xl:my-[7.5rem]',
  'xxl:my-128': '2xl:my-32',
  'xxl:my-156': '2xl:my-[9.75rem]',
  'xxl:my-170': '2xl:my-[10.625rem]',
  'xxl:my-220': '2xl:my-[13.75rem]',
  'xxl:my-270': '2xl:my-[16.875rem]',
  'xxl:my-340': '2xl:my-[21.25rem]',
  'xxl:my-460': '2xl:my-[28.75rem]'
}
